import { FarmRiskType, lookupsJson, StructureCategory } from '@ourbranch/lookups';
import { flattenFarmRisks } from '@ourbranch/farm-utils';

const { agriculturalHeatingSourceOptions } = lookupsJson.farm;

export const getRiskTypeDisplayName = (riskType) => {
  switch (riskType) {
    case FarmRiskType.Fo3:
      return 'FO-3 Standard';
    case FarmRiskType.Fo4:
      return "FO-4 Renter's";
    case FarmRiskType.Fo6Scheduled:
      return 'FO-6 Scheduled';
    case FarmRiskType.Fo6Structures:
      return 'FO-6 Structures';
    case FarmRiskType.Fo6Unscheduled:
      return 'FO-6 Unscheduled';
    default:
      return riskType;
  }
};

export const getAssociatedEntityOptions = (farmLocations) => {
  return flattenFarmRisks(farmLocations).map((risk) => ({
    value: `${getRiskTypeDisplayName(risk.type)} - ${risk.description}`,
    id: risk.id
  }));
};

/**
 * Get heating options based on building type and occupancy for FO6 structures
 * @param {string} buildingType - The type of the building (e.g., Barns/Outbuildings)
 * @param {string} occupancy - The occupancy type of the building
 * @returns {Array} - Filtered heating options
 */
export const getHeatingOptionsByOccupancy = (buildingType, occupancy) => {
  if (buildingType === StructureCategory.BarnsOutbuildings) {
    if (occupancy === 'MH') {
      return agriculturalHeatingSourceOptions.filter((option) => ['HEAT', 'NONE'].includes(option.id));
    }

    if (occupancy === 'GRNA') {
      return agriculturalHeatingSourceOptions.filter((option) => !['HP', 'FR', 'HW', 'RC', 'RF'].includes(option.id));
    }

    return agriculturalHeatingSourceOptions.filter(
      (option) => !['HP', 'FR', 'EB', 'HW', 'RC', 'RF'].includes(option.id)
    );
  }

  if (occupancy === 'PCH') {
    return agriculturalHeatingSourceOptions.filter((option) => !['HP', 'EB', 'RF'].includes(option.id));
  }

  return agriculturalHeatingSourceOptions;
};

export const checkRiskTypeChange = ({ initialValues, currentValues, riskId }) => {
  const findRiskById = (farmLocations, targetRiskId) => {
    for (const location of farmLocations || []) {
      const risk = (location.risks || []).find((risk) => risk.id === targetRiskId);
      if (risk) {
        return risk;
      }
    }
    return null;
  };

  const initialRisk = findRiskById(initialValues?.farmLocations, riskId);
  const currentRisk = findRiskById(currentValues?.farmLocations, riskId);

  if (!initialRisk || !currentRisk) {
    return { riskTypeChanged: false, oldType: null, newType: null };
  }

  const riskTypeChanged = initialRisk.type !== currentRisk.type;

  return {
    riskTypeChanged,
    oldType: initialRisk.type,
    newType: currentRisk.type
  };
};
